import { useTranslation } from 'react-i18next';

import StudentLayout from '@/components/template/StudentLayout';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import HeadTitle from '@/components/ui/custom/HeadTitle';
import { StudentDashboardProvider } from '@/data/context/StudentDashboardContext';
import usePathParamCourseProgressSelection from '@/data/hook/course-progress/usePathParamCourseProgressSelection';
import useAuth from '@/data/hook/useAuth';
import { isStudent } from '@/functions/auth';
import StaffCourseLessonsView from './StaffCourseLessonsView';
import StudentCourseLessonsView from './StudentCourseLessonsView';

export default function CourseLessonsPage() {
  const { t } = useTranslation('translation', { keyPrefix: 'courseLessons' });
  const { user } = useAuth();
  const selection = usePathParamCourseProgressSelection();

  return (
    <StudentLayout>
      <HeadTitle routeInfo={t('title')} />
      <StudentDashboardProvider selection={selection}>
        <ConditionalRenderer
          condition={isStudent(user?.userType)}
          fallback={<StaffCourseLessonsView />}
        >
          <StudentCourseLessonsView />
        </ConditionalRenderer>
      </StudentDashboardProvider>
    </StudentLayout>
  );
}
